module.exports = __webpack_public_path__ + "static/media/Fresh_Blue_TH.b012afe4.png";